<template>
  <div class="callback-messenger-tel">
    <label for="callback-messenger-tel">Номер телефона *</label>
    <input
      id="callback-messenger-tel"
      v-maska="'+7 ### ### ##-##'"
      v-model="phone"
      required
      @input="$emit('update:modelValue', $event.target.value)"
      class="input field__input input-tel-mask"
      :class="{ 'input-tel-mask--error': invalid || error }"
      placeholder="+7 ___ ___ __-__"
    />
    <span v-if="error" class="callback-messenger-tel__error">
      {{ error }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    phone: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>

<style lang="scss">
.callback-messenger-tel {
  display: flex;
  flex-direction: column;
  gap: 11px;

  label {
    font-weight: 500;
    font-size: 12px;
    line-height: 120%;
  }

  .input-tel-mask {
    border-radius: 100px;
    padding: 18px 16px 16px 16px;
    height: 58px;
    // width: 260px;
    font-size: 16px;
    font-weight: 500;
    background: #ff0020;
    border: 1px solid #ffffff70;
    transition: border 0.2s ease;

    &:hover {
      border: 1px solid #ffffff;
    }

    &--error {
      border-color: #fff;
    }

  }

  &__error {
    font-weight: 500;
    font-size: 12px;
    line-height: 120%;
    color: #fff;
  }

  input::placeholder {
    font-size: 16px;
    font-weight: 500;
    color: #ffffff50;
  }

  .input-tel-mask:focus {
    border: 1px solid #ffffff;
    outline: none;
  }
}
</style>
